<template>
    <div class="bottom">
            <elements-category class="categories"/>
    </div>
</template>

<script type="text/babel">
import LayersMixin from '../../../../../../mixins/LayersMixin.vue';
import ImagesCategory from '../../Available/Category/Images/ImagesCategory.vue';
import ElementsCategory from '../../Available/Category/Elements/ElementsCategory.vue';
import Modal from '../../../../../Shared/Modal/FunctionalModal.vue';
import Icon from '../../../../../Shared/Icons/Icon.vue';
export default {
    name: 'WorkspaceAreaBottom',
    data () {
        return {
            selectedCategory: '',
            categories: [
                'images',
                'elements'
            ]
        };
    },
    props: {
        availableLayers: {
            type: Array
        }
    },
    mixins: [LayersMixin],
    components: {
        ImagesCategory,
        ElementsCategory,
        Modal,
        Icon
    },
    methods: {
        closeModal () {
            this.selectedCategory = '';
        },
        chooseLayer (layer) {
            this.$emit('addLayer', layer);
            this.closeModal();
        }
    }
};

</script>

<style lang="scss" scoped>

    .bottom {
        overflow: hidden;
    }

    .categories {
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: calc(100% + 40px);
        overflow-x: auto;

        .category {
            display: flex;
            justify-content: space-between;
            border: 1px solid #ffffff;
            padding: 10px;
            cursor: pointer;
            border-radius: 10px;
            text-transform: uppercase;
            height: 80%;
            width: 30%;
            max-width: 200px;

            .icon {
                width: 80%;
                height: 80%;
                display: block;
                margin: 0 auto;
                &:hover {
                    -webkit-transform: scale(1.1);
                    -moz-transform: scale(1.1);
                    -ms-transform: scale(1.1);
                    -o-transform: scale(1.1);
                    transform: scale(1.1);
                }

            }
        }
    }


</style>
